import { Injectable } from '@angular/core';
import { releaseVersion } from 'release-version';

@Injectable({
  providedIn: 'root'
})
export class ReleaseVersionService {

  constructor() { }

  
  getReleaseVersion(): string {
    return releaseVersion;
  }

}
